import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LineChartDown02 = function LineChartDown02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 21H4.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C3 20.2401 3 19.9601 3 19.4V3m18 12-5.4343-5.4343c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1142.037-.2132.136-.4112.334l-1.8686 1.8687c-.198.198-.297.297-.4112.3341a.5.5 0 0 1-.309 0c-.1142-.0371-.2132-.1361-.4112-.3341L7 7m14 8h-4m4 0v-4"
    })
  }));
};
export default LineChartDown02;